import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function SortableItem({ id, children, className = '' }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    // children is a render function: (dragHandleProps) => JSX
    return (
        <div ref={setNodeRef} style={style} className={className}>
            {children({ ...attributes, ...listeners, style: { cursor: 'grab', touchAction: 'none' } })}
        </div>
    );
}